import React, { useState, useEffect } from 'react';

export const HiddenDivForAnnounce = ({
  toAnnounce,
}) => {
  const [announce, setAnnounce] = useState('');

  useEffect(() => {
    if (toAnnounce && announce !== toAnnounce) {
      setAnnounce(toAnnounce);
    }
  }, [announce, toAnnounce]);

  return (
    <div
      aria-live="polite"
      aria-atomic="true"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        padding: 0,
        margin: '-1px',
        clip: 'rect(0,0,0,0)',
        border: 0,
      }}
    >
      {announce}
    </div>
  );
};
